import { Button, Error, Form, Input, Modal, ValidationStates } from '@opengov/component-library/dist';
import React, { useEffect, useRef, useState } from 'react';

import { ControlBlockStatus } from '../../../../dimensionalTable/types';

import styles from './EditColumnControlBlockModal.scss';

const CONTROL_BLOCK_LABEL_MAX_LENGTH = 30;

export const EditControlBlockModal = ({ closeModal, controlBlockDetails, updateControlBlockName, reportText }) => {
  const nameInput: React.RefObject<HTMLInputElement> = useRef();
  const [blockName, setBlockName] = useState(controlBlockDetails.placeholder);
  const [validationStatus, setValidationStatus] = useState(ValidationStates.None);
  const [validationErrorMessage, setValidationErrorMessage] = useState('');

  useEffect(() => {
    const inputNode = nameInput.current;
    /**
     * Dropdown Popover for control block doesn't loose its focus otherwise and remains open
     * Also it adds to good UX
     */
    if (inputNode) {
      inputNode.focus();
    }
  });

  const { blockIndex, placeholder, description, originalName, controlBlockStatus } = controlBlockDetails;
  const inputProps = {
    id: 'control-block-label-input',
    value: blockName,
    placeholder,
    onChange: (value) => {
      const isEmpty = value.trim() === '';
      if (!isEmpty && value.length <= CONTROL_BLOCK_LABEL_MAX_LENGTH) {
        if (validationStatus !== ValidationStates.Success) {
          setValidationStatus(ValidationStates.Success);
          setValidationErrorMessage('');
        }
      } else {
        setValidationStatus(ValidationStates.Error);
        setValidationErrorMessage(
          isEmpty
            ? reportText.editSectionLabelModal.labelEmpty
            : reportText.editSectionLabelModal.labelMaxLength({ maxLength: CONTROL_BLOCK_LABEL_MAX_LENGTH })
        );
      }
      setBlockName(value);
    },
    validationState: validationStatus
  };

  const updateControlBlockDetails = () => {
    if (validationStatus === ValidationStates.Success) {
      updateControlBlockName({
        controlBlockIndex: blockIndex,
        originalName: originalName,
        displayName: blockName
      });
    }
  };

  const updateInProgress = controlBlockStatus === ControlBlockStatus.Updating;

  return (
    <Modal.Work title={reportText.editSectionLabelModal.title} description={description} onClose={closeModal}>
      <Form.Item htmlFor={inputProps.id} label={reportText.editSectionLabelModal.labelInput} required={true}>
        <Form.CharacterCounter currentCount={blockName.length} maxCount={CONTROL_BLOCK_LABEL_MAX_LENGTH} />
        <Input.Text {...inputProps} ref={nameInput} />
      </Form.Item>
      <Error className={styles.errorMessage} dataTest="errorStateMessage">
        {validationErrorMessage}
      </Error>
      <section>
        <div className={styles.buttons}>
          <Button
            title="cancel"
            dataTest="cancel-rename-control-block"
            onClick={closeModal}
            disabled={updateInProgress}
          >
            {reportText.cancel}
          </Button>
          <Button
            variant="primary"
            loading={updateInProgress}
            onClick={updateControlBlockDetails}
            dataTest="rename-control-block-name-button"
            disabled={[ValidationStates.Error, ValidationStates.None].includes(validationStatus)}
          >
            {reportText.save}
          </Button>
        </div>
      </section>
    </Modal.Work>
  );
};
